
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/shipping",
      function () {
        return require("private-next-pages/info/shipping/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/shipping"])
      });
    }
  